import React,{ useState ,useRef} from 'react';
import { Button,Form,Col,Row,Alert} from 'react-bootstrap';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Logo from '../assets/icons/logo2.jpeg';
import UserNav from './UserNav';

const TermsAndConditionPage = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const candidateID = searchParams.get('id');
    const examType = searchParams.get('exam-type');
    const [success, setSuccess] = useState('');
    const agreeCheckboxRef = useRef(null);
    const disagreeCheckboxRef = useRef(null);
    const handleCheckboxChange = () => {
      setSuccess('')
      if(agreeCheckboxRef.current.checked){
        disagreeCheckboxRef.current.disabled = true;
      }if(disagreeCheckboxRef.current.checked){
        agreeCheckboxRef.current.disabled = true;
      }if(!agreeCheckboxRef.current.checked && !disagreeCheckboxRef.current.checked){
        agreeCheckboxRef.current.disabled = false;
        disagreeCheckboxRef.current.disabled = false;
      }
      // agreeCheckboxRef.current.disabled = !agreeCheckboxRef.current.checked;
      // disagreeCheckboxRef.current.disabled = !disagreeCheckboxRef.current.checked;
    };

    // const agreeCheckbox = document.getElementById('agree');
    // const disagreeCheckbox = document.getElementById('disagree');

    const handleSubmit = () =>{
        if(!agreeCheckboxRef.current.checked && !disagreeCheckboxRef.current.checked){
        setSuccess('Please select at least one checkbox.');
        return;
      }
      else if(agreeCheckboxRef.current.checked && disagreeCheckboxRef.current.checked){
        setSuccess('Please Select Only one Condition agree or disagree');
        return;
      }else if(agreeCheckboxRef.current.checked){
        // navigate(`/users-questions?id=${candidateID}`);
        navigate(`/users-instructions?id=${candidateID}&exam-type=${examType}`)
      }else{
        setSuccess('Sorry your unable to take the test further');
        return;
      }
      }
      const headerStyle = {
        backgroundColor: '#edf2fb',
        padding: '2px',
        display: 'flex',  // Use flexbox for layout
        alignItems: 'center',  // Align items vertically in the center
        justifyContent: 'space-between',  // Add space between items
        position: 'fixed',
        top: 0,
        width:'100%',
    };

    return (
      <>
        
      <UserNav />
     
        <div className='terms-div' style={{paddingTop:50}}>

      <div className='condition-div'>
        <h1>Candidate Terms and Conditions for EngageTalent.AI</h1>

        <p>
          <strong>Voice Recording:</strong>
          By participating in the EngageTalent.AI test, you consent to the recording of your voice during the assessment. The recorded voice may be used solely for the purpose of evaluating verbal communication skills and will be treated with utmost confidentiality.
        </p>

        <p>
          <strong>Answer Explanation:</strong>
          Candidates are required to provide detailed explanations for each answer given in the test. Each explanation should include relevant details and, when applicable, provide an example to illustrate your understanding of the question. Failure to provide sufficient explanations may impact the evaluation of your test results.
        </p>

        <p>
          <strong>Code of Conduct:</strong>
          Candidates are expected to adhere to a code of conduct throughout the test, maintaining a professional and respectful demeanor. Any violation of this code, including but not limited to cheating, impersonation, or any form of dishonesty, may result in immediate disqualification and reporting to relevant authorities.
        </p>

        <p>
          <strong>Data Privacy:</strong>
          DataLake Solutions is committed to protecting your personal data. Please refer to our Privacy Policy for details on how your data will be collected, processed, and stored.
        </p>

        <p>
          <strong>Technical Requirements:</strong>
          Candidates are responsible for ensuring that their devices meet the technical requirements specified for taking the test on the AEngageTalent.AI platform. DataLake Solutions is not liable for any technical issues on the candidate's end that may impact the test experience.
        </p>

        <p>
          <strong>Feedback and Improvement:</strong>
          DataLake Solutions may collect feedback from candidates to improve the EngageTalent.AI platform. Your participation in providing feedback is appreciated and contributes to the enhancement of the assessment process.
        </p>

        <p>
          <strong>Termination of Access:</strong>
          DataLake Solutions reserves the right to terminate or restrict access to the EngageTalent.AI platform for any candidate who violates these terms and conditions. By proceeding with the test on the EngageTalent.AI platform, you acknowledge and agree to abide by these terms and conditions. DataLake Solutions reserves the right to update these terms at any time, and candidates will be notified of any changes.
        </p>

        <Form.Group>
        <Row>
          <Col xs={4}>
            <Form.Check aria-label="option 1" label="Accept" id="agree" ref={agreeCheckboxRef} className='con-checkbox'  onChange={handleCheckboxChange} style={{ fontSize: '15px',whiteSpace: 'nowrap' }}/>
          </Col>
          <Col xs={4}>
            <Form.Check aria-label="option 1"  label="Decline" id="disagree" className='con-checkbox'  ref={disagreeCheckboxRef}   onChange={handleCheckboxChange} style={{ fontSize: '15px',whiteSpace: 'nowrap' }} />
          </Col>
        </Row>
      </Form.Group>
      {success && <Alert variant="danger" className='alert-msgs'>{success}</Alert>}
        <Button variant="dark" onClick={handleSubmit} style={{ marginTop: '10px',paddingBottom:'15px' }}>Continue</Button>
      </div>
      </div>
      <footer>
      <p style={{color:'white'}}>&copy; 2024 Data Lake Solutions LLC. All rights reserved.</p>
      </footer>
      </>
    );
}

export default TermsAndConditionPage;
